import React from 'react'
import { Box, Tooltip } from '@mui/material'
import { getGridStringOperators } from '@mui/x-data-grid-pro'

import { PaginatedBookingColumnType } from '../PaymentHistoryDataGrid'

export const tourTitleColumn: PaginatedBookingColumnType = {
  field: 'title',
  width: 300,
  adminOnly: true,
  sortable: true,
  filterOperators: getGridStringOperators().filter((operator) => operator.value === 'contains' || operator.value === 'equals'),
  renderCell: (params) => params.row.tour
    ? (
      <Tooltip title={params.row.tour.title}>
        <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{params.row.tour.title}</Box>
      </Tooltip>
      )
    : ''
}
